module.exports = __webpack_public_path__ + "static/media/book formatting (1).4936d2e7.png";